<template>
  <div id="i_document">
    <!-- 購物車 -->
    <div
      id="tocart"
      class="cart-icon"
    >
      <a href="#/inquire/checkout">
        <span class="badge badge-pill badge-danger cart-span">
          {{ AllTota }}
        </span>
        <font-awesome-icon
          icon="shopping-cart"
          class="fa-2x"
        />
      </a>
    </div>
    <!-- 項目Tab -->
    <ul
      id="inquire_Tab"
      class="nav nav-tabs"
      role="tablist"
    >
      <li class="nav-item">
        <a
          id="i_document_tab"
          class="nav-link active"
          href="#/inquire/document"
          role="tab"
          aria-controls="i_document_list"
          aria-selected="true"
        >
          證件申請
        </a>
      </li>
      <li class="nav-item">
        <a
          id="i_checkout_tab"
          class="nav-link"
          href="#/inquire/checkout"
          role="tab"
          aria-controls="i_checkout_list"
          aria-selected="false"
        >
          費用結算
        </a>
      </li>
      <li class="nav-item">
        <a
          id="i_order_tab"
          class="nav-link"
          href="#/inquire/order"
          role="tab"
          aria-controls="i_order_list"
          aria-selected="false"
        >
          訂單查詢
        </a>
      </li>
    </ul>
    <!-- 教務證件申請 -->
    <div
      id="i_document_list"
      class="tab-pane fade show active content-color"
      role="tabpanel"
      aria-labelledby="i_document_tab"
    >
      <div class="col-12 pt-3 table-style">
        <!-- 功能欄 -->
        <div class="filter-container">
          <!-- 左邊欄位 -->
          <div class="filter-left">
            <div class="form-group">
              <label for="input-query">篩選資料：</label>
              <input
                id="input-query"
                class="input-style"
                type="text"
                placeholder="請輸入關鍵字"
                v-model="filter"
              >
            </div>
            <div class="form-group">
              <label for="Page-select">筆數：</label>
              <select
                id="Page-select"
                class="input-style"
                v-model="perPage"
              >
                <option
                  v-for="pageOption in pageOptions"
                  :key="pageOption.id"
                  :value="pageOption.value"
                >
                  {{ pageOption.text }}
                </option>
              </select>
            </div>
          </div>

          <!-- 中間欄位（警告訊息）-->
          <div class="filter-center">
            <div class="alert alert-danger alert-custom" role="alert">
              <strong style="color: #dc3545;">
                中華郵政自114年8月26日起 暫停收寄發往美國之商品類郵件<br>
                Mail delivery to the United States has been suspended by Chunghwa Post since August 26, 2025. Delivery of academic documents to U.S. addresses is temporarily unavailable.
              </strong>
            </div>
          </div>
        </div>
        <!-- END 功能欄 -->
        <hr>
        <!-- 表格資料 -->
        <template>
          <b-table
            hover
            small
            bordered
            show-empty
            stacked="md"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <!-- 流水號 -->
            <template v-slot:cell(RowId)="data">
              {{ data.item.RowId }}
            </template>
            <!-- 證件名稱(中+英) -->
            <template v-slot:cell(DocName)="data">
              <span class="dl">
                {{ data.item.DocName }}
              </span>
              <span class="dl">
                {{ data.item.DocEngName }}
              </span>
            </template>
            <!-- 費用 -->
            <template v-slot:cell(DocAmt)="data">
              {{ data.item.DocAmt + ' 元' }}
            </template>
            <!-- 數量加減 -->
            <template v-slot:cell(DocCnt)="data">
              <input
                class="qtyminus catleft"
                type="button"
                value="-"
                @click="downCount(data)"
              >
              <input
                class="qty"
                name="DocCnt"
                type="tel"
                onkeyup="value=value.replace(/[^\d]/g, '')"
                v-model.number="data.item.DocCnt"
              >
              <input
                class="qtyminus catright"
                type="button"
                value="+"
                @click="addCount(data)"
              >
            </template>
            <!-- 加入購物車 -->
            <template v-slot:cell(Action)="data">
              <button
                type="button"
                class="btn btn-primary"
                title="加入"
                @click="checkdata(data.item)"
              >
                <font-awesome-icon icon="plus" />
                加入
              </button>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="public-table"
            class="my-0"
          />
        </template>
        <br>
        <!-- 結帳 -->
        <div class="row pt-3">
          <div class="col-xl-2" />
          <div class="col-xl-8">
            <a
              class="btn btn-primary btn-lg btn-block"
              href="#/inquire/checkout"
              role="button"
            >
              結帳去
            </a>
          </div>
          <div class="col-xl-2" />
        </div>
        <!-- END 結帳 -->
        <br>
      </div>
    </div>
    <!-- 加入-確認基本資訊 -->
    <div
      id="addCenter"
      class="modal fade bd-example-modal-sm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addCenterTitle"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-sm"
        role="document"
      >
        <div class="modal-content content-color">
          <div class="modal-header content-header">
            <h5
              id="addLongTitle"
              class="modal-title"
            >
              確認基本資訊
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="CloseCheck()"
            >
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body content-color">
            <!-- 學年 -->
            <div
              class="form-group"
              v-if="ChcekIsSchoolYear"
            >
              <label
                for="account"
                class="col-form-label"
              >
                學年：
              </label>
              <select
                class="input-style"
                v-model="SchoolYear"
              >
                <option
                  v-for="tes in sYear"
                  :key="tes.id"
                  :value="tes.value"
                >
                  {{ tes.value }}
                </option>
              </select>
            </div>
            <!-- 學期 -->
            <div
              class="form-group"
              v-if="ChcekIsSemester"
            >
              <label
                for="account"
                class="col-form-label"
              >
                學期：
              </label>
              <select
                class="input-style"
                v-model.number="Semester"
              >
                <option value="1">
                  第一學期
                </option>
                <option value="2">
                  第二學期
                </option>
              </select>
            </div>
            <!-- GPA份數 -->
            <!-- <div
              class="form-group"
              v-if="ChcekGPACnt"
            >
              <label
                for="account"
                class="col-form-label"
              >
                GPA份數：
              </label>
              <input
                class="input-style"
                type="number"
                v-model="GPACnt"
                min="0"
              >
            </div> -->
          </div>
          <div class="modal-footer content-color">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="CloseCheck()"
            >
              取消
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              @click="PostOrderAdd()"
            >
              確認加入
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiDocumentsQuery, apiOrderQuery, apiOrderAdd } from '../../apis/api.config.js'
import $ from 'jquery'
import md5 from 'js-md5'
export default {
  data () {
    return {
      fields: [
        { key: 'RowId', label: '#', thClass: 'table-th', variant: 'info', sortable: true },
        { key: 'DocName', label: '教務證件名稱', thClass: 'table-th', class: 'table-long', sortable: true },
        { key: 'DocAmt', label: '費用', thClass: 'table-th', variant: 'warning', sortable: true },
        { key: 'DocCnt', label: '數量', thClass: 'table-th gtd' },
        { key: 'WorkTime', label: '作業時間', thClass: 'table-th' },
        { key: 'Remark', label: '備註', thClass: 'table-th' },
        { key: 'DocType', label: '證件類型', thClass: 'table-th', sortable: true },
        { key: 'Action', label: '功能', thClass: 'table-th sdf' }
      ],
      items: [], // 證件種類資料
      OrderData: [],
      Docidentity: '',
      totalRows: 1, // 分頁參數
      currentPage: 1,
      perPage: 10, // 起始筆數數量
      pageOptions: [ // 筆數數量選項
        { text: '15', value: '15' },
        { text: '30', value: '30' },
        { text: '50', value: '50' }
      ],
      SchoolYear: '',
      test: [
        { text: '108', value: '108' },
        { text: '109', value: '109' },
        { text: '110', value: '110' }
      ],
      Semester: null,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      ChcekGPACnt: false,
      ChcekIsSchoolYear: false,
      ChcekIsSemester: false,
      GPACnt: 0,
      UserTypeData: 0,
      AllTota: 0,
      sYear: JSON.parse(localStorage.getItem('A_Year'))
    }
  },
  mounted () {
    this.PostDocumentsQuery()
    this.tocart()
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  watch: {
    items: { // 特定檢查寫在這裡
      deep: true,
      handler: function (value) {
        value.forEach(e => {
          if (e.DocCnt >= (e.Limit === 0 ? 50 : e.Limit)) {
            e.DocCnt = (e.Limit === 0 ? 50 : e.Limit)
          } else if (e.DocCnt <= 0) {
            e.DocCnt = 0
          }
        })
      }
    }
  },
  methods: {
    tocart () { // API007 購物車
      // 定義資料
      const StudentData = JSON.parse(localStorage.getItem('A_StudentData'))
      const NewData = JSON.parse(localStorage.getItem('A_Identity'))
      if (!NewData) {
        return
      }
      NewData.OrderType = 1 // 未結帳
      NewData.StudentId = StudentData.StudentId
      // 呼叫API
      apiOrderQuery(NewData).then(
        response => {
          if (response.status === 200) {
            if (response.data.ErrorCode === 0) {
              this.AllTota = response.data.Data[0].DocList.length
            }
          }
        }
      )
    },
    PostDocumentsQuery () { // API003 證件種類查詢
      // 定義資料
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('A_Identity'))
      const UserType = localStorage.getItem('A_UserType')
      if (!NewData) {
        vm.ErrorModal('請登入。')
        vm.$bus.$emit('MenuLoginOut', 'false')
        return false
      }
      vm.$bus.$emit('Loading', true)
      const TypeDataA = md5('在校生')
      const TypeDataB = md5('校友')
      if (UserType === TypeDataA) {
        vm.UserTypeData = 1
      } else if (UserType === TypeDataB) {
        vm.UserTypeData = 2
      }
      NewData.DocType = vm.UserTypeData
      apiDocumentsQuery(NewData).then(
        response => {
          vm.$bus.$emit('Loading', false)
          if (response.status === 200) {
            if (response.data.ErrorCode === 0) {
              for (let i = 0; i < response.data.Data.length; i++) { // 遍歷GET data
                const json = response.data.Data[i] // 添增Count屬性
                json.DocCnt = 0
                if (json.DocType === 1) {
                  json.DocType = '在校生'
                } else if (json.DocType === 2) {
                  json.DocType = '畢業生'
                } else if (json.DocType === 3) {
                  json.DocType = '在校生/畢業生'
                }
              }
              vm.items = response.data.Data
              vm.totalRows = vm.items.length
            } else {
              vm.ErrorModal(response.data.Msg)
              if (response.data.ErrorCode === 41221) {
                vm.$bus.$emit('MenuLoginOut', 'false')
              }
              return false
            }
          } else {
            vm.ErrorModal(response.data.Msg)
          }
        }
      )
    },
    addCount (data) { // 數量加，不得大於50
      if (data.item.DocCnt >= (data.item.Limit === 0 ? 50 : data.item.Limit)) {
        data.item.DocCnt = (data.item.Limit === 0 ? 50 : data.item.Limit)
      } else {
        data.item.DocCnt++
      }
    },
    downCount (data) { // 數量減
      if (data.item.DocCnt <= 0) {
        data.item.DocCnt = 0
      } else {
        data.item.DocCnt -= 1
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    checkdata (data) {
      const vm = this
      if (data.DocCnt >= 1) { // 判斷數量
        if (data.IsSchoolYear === 1) { // 是否需輸入學年 0:否 1:是
          vm.ChcekIsSchoolYear = true
        }
        if (data.IsSemester === 1) { // 是否需輸入學期 0:否 1:是
          vm.ChcekIsSemester = true
        }
        if (data.IsGPA === 1) { // 判斷英文歷年成績單
          vm.ChcekGPACnt = true
          vm.GPACnt = data.DocCnt
        }
        if (vm.ChcekIsSchoolYear || vm.ChcekIsSemester) {
          $('#addCenter').modal('show') // 顯示彈跳視窗
          vm.OrderData = data
        } else {
          vm.OrderData = data
          if (!vm.ChcekGPACnt) {
            vm.GPACnt = 0
          }
          vm.PostOrderAdd()
        }
      } else {
        vm.ErrorModal('數量最少要1份。')
        return false
      }
    },
    PostOrderAdd () {
      // 定義資料
      const vm = this
      var ErrorText = ''
      // 判斷有無需學年學期
      if (vm.ChcekIsSchoolYear) {
        if (vm.SchoolYear === '') {
          ErrorText = '請選擇學年。'
          vm.OrderData = []
        }
      }
      if (vm.ChcekIsSemester) {
        if (vm.Semester === '') {
          ErrorText = '請選擇學期。'
          vm.OrderData = []
        } else {
          if (vm.Semester !== 1 && vm.Semester !== 2) {
            ErrorText = '學期請輸入1或2。'
          }
        }
      }
      if (ErrorText !== '') {
        vm.ErrorModal(ErrorText)
        return false
      }
      if (vm.ChcekIsSchoolYear || vm.ChcekIsSemester || vm.ChcekGPACnt) {
        vm.ChcekIsSchoolYear = false
        vm.ChcekIsSemester = false
        vm.ChcekGPACnt = false
        $('#addCenter').modal('hide') // 關閉彈跳視窗
      }
      // 判斷項目數量
      if (vm.OrderData.DocCnt >= 1 && vm.OrderData.DocCnt <= 50) { // 數量1~50
        const StudentData = JSON.parse(localStorage.getItem('A_StudentData'))
        const NewData = JSON.parse(localStorage.getItem('A_Identity'))
        NewData.DocId = vm.OrderData.DocId
        NewData.DocCnt = vm.OrderData.DocCnt
        NewData.StudentId = StudentData.StudentId
        NewData.SchoolYear = vm.SchoolYear
        NewData.Semester = vm.Semester
        NewData.GPACnt = vm.GPACnt
        NewData.Pclass = StudentData.Pclass ? StudentData.Pclass : 1
        // 呼叫API
        apiOrderAdd(NewData).then(
          response => {
            vm.$bus.$emit('Cart', 'true')
            vm.SchoolYear = ''
            vm.Semester = ''
            vm.GPACnt = 0
            if (response.data.ErrorCode === 0) { // 回應成功
              vm.tocart()
              vm.$bus.$emit('Modals', '已加入購物車。')
              $('#CheckOk').modal('show')
            } else {
              vm.ErrorModal(response.data.Msg)
            }
          }
        )
      } else {
        vm.ErrorModal('數量起碼要大於1筆，小於50筆。')
      }
      // 數量歸零
      vm.ConutZero(vm.items)
    },
    CloseCheck () {
      const vm = this
      vm.ChcekIsSchoolYear = false
      vm.ChcekIsSemester = false
      vm.ChcekGPACnt = false
      vm.SchoolYear = ''
      vm.Semester = ''
      vm.GPACnt = 0
      // 數量歸零
      vm.ConutZero(vm.items)
    },
    ConutZero (data) {
      for (let i = 0; i < data.length; i++) {
        const json = data[i]
        json.DocCnt = 0
      }
    },
    ErrorModal (data) {
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>
<style lang="scss">
.qty {
  width: 40px;
  height: 39px;
  text-align: center;
  border: 0;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button{
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
}
input.qtyplus {
  width: 25px;
  height: 35px;
  border: 1px solid #aaa;
  background: #f8f8f8;
}
input.qtyminus {
  width: 25px;
  height: 39px;
  border: 1px solid #aaa;
  background: #f8f8f8;
}
.catleft {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.catright {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}
@media only screen and (max-width:767px) {
  .qty {
    height: 39px;
  }
}
a {
      color: #000000;
      text-decoration: none;
      background-color: transparent;
  }
  a:hover {
    text-shadow: rgba(0, 0, 0, 0.308) 0.1em 0.1em 0.2em;
  }
  #tocart {
    cursor: pointer;
  }
  .cart-icon{
    display: block;
    right: 3%;
    position: fixed;
    top: 78%;
    float:right;
    z-index: 999;
    color: #ffc300d1;
  }
  .cart-span {
    position: fixed;
    display: block;
    float:right;
    right: 3.2%;
    z-index: 999;
  }
  @media only screen and (max-width:600px) {
    .cart-icon {
      top: 80%;
    }
  }
  .sdf {
    width: 90px;
  }
  .gtd {
    width: 105px;
  }
</style>
